import { IconLock } from '@components/icons/lock';
import { Text } from '@components/text';

import { Box } from 'components/Box';

// Shared visual cues marking a note as admin-only (restricted). Used by both
// the application-notes and job-notes screens so the treatment stays in sync.

export const AdminAccentBar = () => (
  <Box
    w="4px"
    noShrink
    borderRadius="8px"
    style={{ alignSelf: 'stretch', backgroundColor: 'var(--color-element-orange-100)' }}
  />
);

export const AdminOnlyLabel = ({ text }: { text: string }) => (
  <Text font="regular14" color="textSecondary">
    *{text}
  </Text>
);

export const AdminNoteInfo = ({ text }: { text: string }) => (
  <Box flex alignItems="center" gap="4" mt="8">
    <IconLock size={16} color="elementPurple50" />
    <Text font="regular14" color="textSecondary">
      {text}
    </Text>
  </Box>
);
